import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/farm-icon.svg'

const FarmIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon viewBox={'0 0 49 49'} component={Icon} {...props} fill="currentColor" sx={[{ width: '100%', height: '100%', color: 'primary.main' }]} />
)
export default FarmIcon
